import { Alert, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import {
  PostSubmissionState,
  readSubmittedMarker,
} from "./components/PostSubmissionState";
import taskerAuth from "../../services/taskerAuth";

/**
 * Vendor onboarding post-submit status page. We deliberately do NOT poll
 * Tasker for task-status changes here — row-level auth revokes the vendor's
 * read within seconds of submit, so any interim "Awaiting Approval" screen
 * bounced straight to a 404 anyway. Instead we render the static
 * PostSubmissionState card from the local submission marker written on
 * successful submit; downstream status (approval, send-back, reject) is
 * communicated over email.
 */
function VendorOnboardingStatus() {
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("task_id") ?? searchParams.get("taskId");

  if (!taskId) {
    return (
      <Box sx={{ maxWidth: 720, mx: "auto", mt: 8, p: 3 }}>
        <Alert severity="error">
          Missing task_id in the URL. Use your invitation link.
        </Alert>
      </Box>
    );
  }

  const marker = readSubmittedMarker(taskId, taskerAuth.getVendorMobile());
  if (marker) return <PostSubmissionState marker={marker} />;

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", mt: 8, p: 3 }}>
      <Alert severity="error">
        This application isn&apos;t available for your account. Please check
        the link or contact your Livspace representative.
      </Alert>
    </Box>
  );
}

export default VendorOnboardingStatus;
